import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ResultSummaryComponent } from "./result-summary.component";
import { TranslateModule } from "@ngx-translate/core";
import { ValgMessageBarModule } from '@valg-shared/components/valg-message-bar/valg-message-bar.module';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        ValgMessageBarModule
    ],
  declarations: [
    ResultSummaryComponent
  ],
  exports: [
    ResultSummaryComponent
  ]
})
export class ResultSummaryModule {}
